import CnpjUtils from "../../../shared/utils/CnpjUtils";

export const getClientSearchFormConfig = clientSearchDocument => [
    {
        name: "clientSearchDocument",
        label: "CNPJ do cliente",
        type: "text",
        value: clientSearchDocument,
        placeholder: "Digite o CNPJ",
        mask: CnpjUtils.getAlphanumericCnpjMask(),
        guide: false,
        columns: 12
    }
];